import React, { useState, useEffect, useContext } from "react";
import styles from "./Market.module.sass";
// import cn from "classnames";
import Row from "./Row";
import { getOrders, getSellerById } from "../../../Firebase/firebaseDatabase";
import { GlobalState } from "../../../App";
import LoadingIndicator from "../../../LoadingScreen/LoadingIndicator";
import Icon from "../../../components/Icon";
import { toIsoString } from "../../../utils/extensions";

const Market = ({ searchBy }) => {

  const [selectedFilters, setSelectedFilters] = useState([]);

  const {
    setIsActionComplete, ordersFilterBy
  } = useContext(GlobalState)

  const handleChange = (id) => {
    if (selectedFilters.includes(id)) {
      setSelectedFilters(selectedFilters.filter((x) => x !== id));
    } else {
      setSelectedFilters((selectedFilters) => [...selectedFilters, id]);
    }
  };

  const [loading, setLoading] = useState(true)

  const [allOrders, setAllOrders] = useState()
  const [itemsList, setItemsList] = useState()
  const [itemsFinalList, setItemsFinalList] = useState()

  const [isPrevActive, setIsPrevActive] = useState(false)
  const [isNextActive, setIsNextActive] = useState(true)
  const [activePageNum, setActivePageNum] = useState(1)
  const [pageCount, setPageCount] = useState(1)

  const page_items_count = 100;
  const [range, setRange] = useState({
    start: 0,
    end: page_items_count
  })

  const calculatePageCount = (active_products) => {
    const calculated_page_count = active_products?.length / page_items_count;
    const check_if_isInteger = Number.isInteger(calculated_page_count)
    if (check_if_isInteger) {
      setPageCount(calculated_page_count)
      if (calculated_page_count === 1) {
      }
    } else {
      setPageCount(Math.floor(calculated_page_count) + 1)
      if (Math.floor(calculated_page_count) + 1 === 1) {
      }
    }
  }

  const getAllOrders = async () => {
    try {
      await getOrders().then(list => {
        list.forEach((item, i, array) => {

          list[i].data.dateCreated = toIsoString(new Date(
            item.data.dateCreated?.seconds * 1000 + item.data.dateCreated?.nanoseconds / 1000000
          ))

          if (item.data?.dateExtended !== '') {
            list[i].data.dateExtended = toIsoString(new Date(
              item.data?.dateExtended?.seconds * 1000 + item.data?.dateExtended?.nanoseconds / 1000000
            ))
          }

          if (item.data.status === "IN PROGRESS") {
            if (item.data.shippingTimeframe !== "") {
              const shippingTimeFrameDays = list[i]?.data?.shippingTimeframe.split('-')[1]?.split(" ")[0]
              // .split('-')[1].split(" ")[0]
              console.log("time frame",shippingTimeFrameDays)
              console.log("date extended",item.data?.dateExtended)
              // if (item.data?.dateExtended === '' || item.data?.dateExtended === undefined) {
                const dateCreate = new Date(item?.data?.dateCreated)
                console.log("create date",dateCreate)
                const checkDate = new Date(dateCreate.setDate(dateCreate.getDate() + parseInt(shippingTimeFrameDays)))
                console.log("check date",checkDate)
                if (new Date() >= checkDate) {
                  list[i].data.status = "NEED ATTENTION"
                  console.log("check final condition:",new Date() >= checkDate)
                }
              // }
            }
          }
          if (item?.data.status === "EXTENDED") {
            const extendedDate = new Date(item.data?.dateExtended)
            if (item?.data?.shippingTimeframe !== '') {
                if (new Date() >= extendedDate) {
                    item.data.status = "NEED ATTENTION"
                }
            }
             else {
                if (new Date() >= extendedDate) {
                   item.data.status = "NEED ATTENTION"
                }
            }

        }

          if (array.length - 1 === i) {
            setAllOrders(list)
            setLoading(false)
          }

        });

      })

    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    setLoading(true)
    setIsActionComplete(false)
    getAllOrders()
  }, []);

  useEffect(() => {
    if (searchBy !== '') {
      const filteredList = itemsList?.filter(data => {
        if (data?.data?.id.toUpperCase() === searchBy.toUpperCase()) {
          return data
        }
      })

      setItemsFinalList(filteredList)
      calculatePageCount(filteredList)
    } else {
      setItemsFinalList(itemsList)
      calculatePageCount(itemsList)
    }

  }, [itemsList, searchBy])

  useEffect(() => {
    if (allOrders?.length !== 0) {
      if (ordersFilterBy !== 'Select status' && ordersFilterBy !== 'All' && ordersFilterBy !== "") {
        const filteredList = allOrders?.filter(data => {
          if (data?.data?.status === ordersFilterBy.toUpperCase()) {
            return data
          }
        })
        setItemsList(filteredList)
      } else {
        setItemsList(allOrders)
        // calculatePageCount(allOrders)
      }
    }
  }, [allOrders, ordersFilterBy])


  const handleChangePrevClick = () => {

    if (activePageNum > 1) {
      setIsNextActive(true)
      const updatedPageNum = activePageNum - 1;
      setActivePageNum(updatedPageNum)

      if (updatedPageNum === 1) {
        setIsPrevActive(false)
      } else {
        setIsPrevActive(true)
      }

      setRange({
        start: updatedPageNum * page_items_count - page_items_count,
        end: updatedPageNum * page_items_count
      })
    } else {
      setIsPrevActive(false)
    }
  }

  const handleChangeNextClick = () => {

    if (activePageNum < pageCount) {
      setIsPrevActive(true)
      const updatedPageNum = activePageNum + 1;
      setActivePageNum(updatedPageNum);

      if (updatedPageNum === pageCount) {
        setIsNextActive(false)
      } else {
        setIsNextActive(true)
      }

      setRange({
        start: updatedPageNum * page_items_count - page_items_count,
        end: updatedPageNum * page_items_count
      })

    } else {
      setIsNextActive(false)
    }
  }

  return (
    <div className={styles.market}>
      {
        loading !== true ?
          <>
            <div className={styles.table}>
              <div className={styles.row}>
                <div className={styles.col}>Customer name</div>
                <div className={styles.col}>Order ID</div>
                <div className={styles.col}>Total</div>
                <div className={styles.col}>Status</div>
                <div className={styles.col}>Date created</div>
                <div className={styles.col}>Sales channel</div>
              </div>
              {itemsFinalList
                ?.sort((a, b) => {
                  return (
                    new Date(b?.data?.dateCreated).getTime() - new Date(a?.data?.dateCreated).getTime()
                  )
                })
                ?.map((x, index) => {
                  return (
                    (index >= range.start) && (index < range.end) ?
                      x.data.id !== undefined &&
                      <Row
                        item={x.data}
                        key={index}
                        value={selectedFilters.includes(x.id)}
                        onChange={() => handleChange(x.id)}
                        up={itemsList.length - index <= 2}
                      /> : <></>
                  )
                }
                )}
            </div>
            {
              pageCount !== 0 && pageCount !== 1 ?
                <div className={styles.foot}>
                  <button
                    style={{
                      opacity: isPrevActive ? 1 : 0.1
                    }}
                    onClick={() => {
                      handleChangePrevClick()
                    }} className={styles.arrow}>
                    <Icon name="arrow-left" size="20" />
                  </button>

                  <button
                    style={{
                      opacity: isNextActive ? 1 : 0.1
                    }}
                    onClick={() => {
                      handleChangeNextClick()
                    }} className={styles.arrow}>
                    <Icon name="arrow-right" size="20" />
                  </button>
                </div>
                : <></>
            }
          </>
          :
          <LoadingIndicator />
      }


    </div>
  );
};

export default Market;
